/**
 * Плашка "Як обрати розмір?" (2026-08-28) — app-block size-chart рендерится
 * корректно (в отличие от сломанного Judge.me preview_badge, см. CLAUDE.md),
 * но стоит отдельным блоком ВЫШЕ селектора вариантов (main-product.liquid,
 * block_order). Переносим его сюда, в JS, а не через Liquid: он рендерится
 * в родительском main-product.liquid цикле по block_order (общий для ЛЮБОГО
 * @app-блока), а сам селектор вариантов на этом сайте рисует ПРИЛОЖЕНИЕ
 * Globo Swatch (см. ниже) — протащить туда app-block Liquid-параметром было
 * бы куда рискованнее, чем просто переставить готовый DOM-узел после рендера.
 *
 * ВАЖНО (найдено эмпирически 2026-08-28, две ловушки подряд):
 * 1) Реальный видимый селектор размера рисует НЕ нативный variant-picker
 *    темы (тот стоит с классом "no-js-hidden" и остаётся скрытым — Globo
 *    Swatch полностью подменяет его своей вёрсткой), а .globo-swatch-list
 *    от приложения Globo Color Swatch:
 *    <legend class="name-option" data-name="Size">Size<span class="name-variant">...
 * 2) Globo рендерит эту вёрстку АСИНХРОННО, уже ПОСЛЕ DOMContentLoaded —
 *    попытка найти .name-option сразу на DOMContentLoaded ничего не находит
 *    (Globo ещё не отрисовался), скрипт тихо проваливался в фолбэк на
 *    нативный (скрытый) fieldset темы — кнопка технически переставлялась,
 *    но оставалась невидимой. Поэтому ждём появления через MutationObserver,
 *    а не разовую проверку.
 * 3) <legend class="name-option"> у Globo упрямо остаётся computed
 *    display:block, даже через `display: inline-block !important` (и даже
 *    через page.addStyleTag с ещё более специфичным селектором — проверено
 *    эмпирически, не помогло). Вместо борьбы за display самой легенды —
 *    оборачиваем ЕЁ И кнопку в свой flex-контейнер: во flex-контексте ряд
 *    задаёт РОДИТЕЛЬ, а не display самого элемента, так что "упрямый" блок
 *    всё равно встаёт в строку.
 * 4) Видимый "скачок" (2026-08-29): кнопка на долю секунды рендерится в
 *    исходном месте, потом резко переезжает при переносе — CSS прячет
 *    .size-chart-trigger (opacity:0) по умолчанию, здесь показываем её
 *    (.size-chart-trigger--ready) только когда она УЖЕ на финальной
 *    позиции. showTrigger() вызывается во всех исходах (успех, фолбэк,
 *    и даже полный провал через failsafe) — иначе кнопка рискует остаться
 *    невидимой навсегда, если Globo вообще не найден.
 */
document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.size-chart-trigger');
  if (!trigger) return;

  var appBlock = trigger.closest('.shopify-app-block') || trigger.parentElement;
  if (!appBlock) return;

  var sizeOptionNames = ['size', 'розмір', 'размер'];
  var done = false;

  function findGloboTarget() {
    var globoLegends = document.querySelectorAll('.globo-swatch-list .name-option[data-name]');
    for (var i = 0; i < globoLegends.length; i += 1) {
      var gName = (globoLegends[i].getAttribute('data-name') || '').trim().toLowerCase();
      if (sizeOptionNames.indexOf(gName) !== -1) return globoLegends[i];
    }
    return null;
  }

  function findNativeFallbackTarget() {
    var fieldsets = document.querySelectorAll('.option-selector[data-option]');
    var target = null;
    for (var j = 0; j < fieldsets.length; j += 1) {
      var name = (fieldsets[j].getAttribute('data-option') || '').trim().toLowerCase();
      if (sizeOptionNames.indexOf(name) !== -1) {
        target = fieldsets[j];
        break;
      }
    }
    if (!target) target = fieldsets[0];
    return target ? target.querySelector('.label') : null;
  }

  function showTrigger() {
    // requestAnimationFrame — даём браузеру один кадр применить новую
    // позицию в разметке ДО того, как начнётся CSS-переход opacity, иначе
    // переход иногда стартует от уже показанного состояния и не виден.
    requestAnimationFrame(function () {
      trigger.classList.add('size-chart-trigger--ready');
    });
  }

  function move(legend) {
    if (done) return;
    done = true;

    if (legend) {
      appBlock.classList.add('size-chart-block-wrapper--inline');
      var row = document.createElement('div');
      row.className = 'size-chart-inline-row';
      legend.parentElement.insertBefore(row, legend);
      row.appendChild(legend);
      row.appendChild(appBlock);
    }
    // если legend не нашли вообще — кнопка остаётся на исходном месте,
    // но всё равно должна стать видимой (иначе пропадёт совсем)

    showTrigger();
  }

  var immediateTarget = findGloboTarget();
  if (immediateTarget) {
    move(immediateTarget);
    return;
  }

  var observer = new MutationObserver(function () {
    var target = findGloboTarget();
    if (target) {
      observer.disconnect();
      move(target);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Если за 6с Globo так и не отрисовался (не установлен на товаре, сбой
  // сети и т.п.) — перестаём ждать и подстраховываемся нативным fieldset
  // темы (может остаться скрытым сам по себе, но это уже не наша логика).
  setTimeout(function () {
    if (done) return;
    observer.disconnect();
    move(findNativeFallbackTarget());
  }, 6000);
});
